import React, {useState} from 'react';
import {List} from 'antd';
import {useParams} from "react-router-dom";
import ModalVideo from 'react-modal-video';
import {useAuth} from "../../../providers/AuthProvider";
import InterviewStepDetail from "./InterviewStepDetail";
import {useAPI} from "../../../config/API";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ErrorBanner from "../../../components/ErrorBanner";


const TalentInterviewSteps = ({children,...props}) => {

    const {auth, isUpdating, talentUpdate, update: updateAuth} = useAuth();
    const {currentStep, "*": other} = useParams();

    const {
        data: steps,
        error,
        refetch,
        isFetching,
    } = useAPI('fetchLatestVideoInterviewForTalent', {
        initialData: TB.map(TB.orderBy(laravel.talent_video_interview_steps || [], 'display_index', 'asc'), step => {
            let existingStep = TB.find(auth?.talent_video_interviews || [], ['step.id', step.id]);

            if (existingStep) {
                let {
                    step:stepInfo,
                    ...latest_interview
                } = existingStep;
                return {
                    ...step,
                    latest_interview
                }
            }
            return step;
        }),
        onSuccess: (data) => {
            console.log('onSuccess', data)
        },
        onError: (error) => {
            console.log('onError', error)
        }
    })
    const [previewingVideo, setPreviewingVideo] = useState(null)

    return (
        <React.Fragment>
            {children}

            {isFetching ? (
                <div className="flex flex-col p-8 flex-grow items-center justify-center">
                    <LoadingSpinner  size="lg"/>
                </div>
            ) : (error ? (
                <ErrorBanner
                    title="Something went wrong"
                    message="Unable to load talent. Please try again later"
                    onRetry={refetch} />
            ) : (
                <React.Fragment>
                    <List itemLayout="vertical" dataSource={steps} renderItem={(item, index) => (
                        <List.Item className="border-t first:border-t-0 py-4">
                            <InterviewStepDetail
                                isActive={parseInt(currentStep) === item.display_index}
                                step={item}
                                {...props}
                                isDisabled={props.isDisabled} onPreview={setPreviewingVideo}/>
                        </List.Item>
                    )}/>
                    <ModalVideo
                        channel="custom"
                        url={previewingVideo}
                        isOpen={!!previewingVideo}
                        onClose={() => setPreviewingVideo(false)}
                    />
                </React.Fragment>
            ))}
        </React.Fragment>
    )
};

export default TalentInterviewSteps;